// javascript
// File: `src/views/songbooks/SongBooksDropdown.jsx`

import React from 'react';
import Api from "../../components/helpers/Api";
import { Button, Row, Progress } from "reactstrap";
import { RiDeleteBin6Line } from "@remixicon/react";
import { RiAddLine, RiHeartFill } from "react-icons/ri";
import Select from "react-select";

class SongBooksDropdown extends React.Component {
    state = {
        isLoading: false,
        listItems: [],
        selectedSongBooks: [],
        chosenSongBooksButtons: null,
        isSelectFocused: false,
    };

    selectRef = React.createRef();

    componentDidMount() {
        this.setState({ isLoading: true });

        Api.get(`/song-books`)
            .then((res) => {
                const listItems = res.data;
                sessionStorage.setItem("songBooks", JSON.stringify(listItems));
                this.setState({ listItems, isLoading: false });
            })
            .catch(err => {
                console.error("Error loading song books:", err);
                this.setState({ isLoading: false });
            });

        let songBooks = [];
        try {
            if (!sessionStorage.getItem("alreadyRendered") && sessionStorage.getItem("loadPreferences") !== "false") {
                const preferred = sessionStorage.getItem("preferred-song-books");
                const preferredSongBooks = preferred ? JSON.parse(preferred) : [];
                const sessionValue = sessionStorage.getItem(this.props.sessionPropName);
                const selected = sessionValue ? JSON.parse(sessionValue) : [...preferredSongBooks];
                songBooks = Array.isArray(selected) ? selected : [];
            } else {
                const sessionValue = sessionStorage.getItem(this.props.sessionPropName);
                const parsed = JSON.parse(sessionValue);
                songBooks = Array.isArray(parsed) ? parsed : [];
            }
        } catch {
            songBooks = [];
        }

        if (songBooks.length > 0) {
            const uniqueSongBooks = [];
            const seenIds = new Set();

            songBooks.forEach(sb => {
                if (sb && !seenIds.has(sb.id)) {
                    seenIds.add(sb.id);
                    uniqueSongBooks.push(sb);
                }
            });

            this.setState({
                chosenSongBooksButtons: uniqueSongBooks
                    .sort((a, b) => (a?.title || '').localeCompare(b?.title || ''))
                    .map((theme, index) => this.showPill(index, theme))
            });
        }

        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        const isCmdOrCtrlA = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'a';
        if (isCmdOrCtrlA && this.state.isSelectFocused && this.isLoggedIn()) {
            e.preventDefault();
            const allOptions = this.state.listItems
                .filter(item => !this.getAllSelected().some(existing => existing.id === item.id))
                .map(item => ({ id: item.id, title: item.title }));

            this.setState({ selectedSongBooks: allOptions });

            const formatted = allOptions.map(option => ({ value: option.id, label: option.title }));
            this.selectRef.current.setValue(formatted, 'select-option');
        }
    };

    addSongBooksToList = () => {
        const allSelected = this.getAllSelected();
        if (allSelected.length === 1 && !this.isLoggedIn()) return;

        const newSelections = this.state.selectedSongBooks.filter(
            sb => !allSelected.some(existing => existing.id === sb.id)
        );

        if (newSelections.length > 0) {
            const existing = (() => {
                try {
                    const parsed = JSON.parse(sessionStorage.getItem(this.props.sessionPropName));
                    return Array.isArray(parsed) ? parsed : [];
                } catch {
                    return [];
                }
            })();

            const updated = [...existing, ...newSelections];
            sessionStorage.setItem(this.props.sessionPropName, JSON.stringify(updated));

            const preferredIds = (() => {
                try {
                    const psb = JSON.parse(sessionStorage.getItem("preferred-song-books"));
                    return Array.isArray(psb) ? psb.map(p => p.id) : [];
                } catch {
                    return [];
                }
            })();

            this.setState({
                chosenSongBooksButtons: updated
                    .sort((a, b) => (a?.title || '').localeCompare(b?.title || ''))
                    .map((theme, index) => this.showPill(index, theme, preferredIds)),
                selectedSongBooks: [],
            });

            this.props.enableActiveButtonHandler(true);
            sessionStorage.setItem("songBooksContinueEnabled", true);
        }
    };

    getAllSelected = () => {
        let selected = [], preferred = [];
        try {
            const raw = sessionStorage.getItem(this.props.sessionPropName);
            selected = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
        } catch {}
        try {
            const raw = sessionStorage.getItem("preferred-song-books");
            preferred = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
        } catch {}
        return [...selected, ...preferred];
    };

    removePill = (songBook) => {
        const updated = this.getAllSelected().filter(sb => sb.id !== songBook.id);
        sessionStorage.setItem(this.props.sessionPropName, JSON.stringify(updated));

        const preferred = (() => {
            try {
                const parsed = JSON.parse(sessionStorage.getItem("preferred-song-books"));
                return Array.isArray(parsed) ? parsed.filter(sb => sb.id !== songBook.id) : [];
            } catch {
                return [];
            }
        })();
        sessionStorage.setItem("selected-song-books", JSON.stringify(updated));

        this.setState({
            chosenSongBooksButtons: updated
                .sort((a, b) => (a?.title || '').localeCompare(b?.title || ''))
                .map((theme, index) => this.showPill(index, theme, preferred.map(p => p.id))),
        });
        this.props.enableActiveButtonHandler(true);
    };

    showTitle(songBook) {
        const allBooks = JSON.parse(sessionStorage.getItem("songBooks")) || [];
        const full = allBooks.find(sb => sb.id === songBook.id);
        const title = full?.title || songBook.title;
        return title.length <= 20 ? title : full?.shortTitle || title.slice(0, 19) + "...";
    }

    showPill = (index, songBook) => {
        const preferred = JSON.parse(sessionStorage.getItem("preferred-song-books") || "[]");
        const isPreferred = preferred.some(p => p.id === songBook.id);

        return (
            <div key={index} className="pill-container">
                <Button
                    className="text-uppercase"
                    color="primary"
                    size="sm"
                    style={{ width: "100%" }}
                    title={songBook.title}
                >
                <span style={{ fontSize: "0.7rem" }}>
                    {isPreferred && (
                        <RiHeartFill
                            size={18}
                            style={{ color: "white", float: "left" }}
                        />
                    )}
                    &nbsp;{this.showTitle(songBook)}
                </span>

                    {/* Only show delete icon if NOT a preferred book */}
                    {!isPreferred && (
                        <>
                            &nbsp;
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.removePill(songBook);
                                }}
                                className="btn-inner--icon ml-1"
                                title={`Remove ${songBook.title} from selected song books`}
                            >
                                <RiDeleteBin6Line
                                    size={18}
                                    style={{ color: "white", float: "right" }}
                                />
                            </a>
                        </>
                    )}
                </Button>
            </div>
        );
    };

    isLoggedIn = () => !!sessionStorage.getItem("customer");

    render() {
        const customStyles = {
            option: (styles, { isDisabled, isSelected }) => ({
                ...styles,
                color: isDisabled ? "#999" : styles.color,
                backgroundColor: isDisabled ? "#f8f9fa" : isSelected ? "#e9ecef" : styles.backgroundColor,
                cursor: isDisabled ? "not-allowed" : "default",
            }),
        };

        const allSelected = this.getAllSelected().map(sb => sb.id);
        const options = this.state.listItems.filter(i => !allSelected.includes(i.id)).map(i => ({ value: i.id, label: i.title }));
        const value = this.state.selectedSongBooks.map(sb => ({ value: sb.id, label: sb.title }));
        const addButtonEnabled = this.isLoggedIn() || (allSelected.length < 1);

        return (
            <div>
                <Row><div className="col-9 my-1">Song Books</div></Row>
                {!this.isLoggedIn() && (
                    <Row>
                        <div className="col-9 my-1 text-muted" style={{ opacity: 0.6, fontSize: "0.9rem" }}>
                            Using multiple song books is available to logged in users
                        </div>
                    </Row>
                )}
                {this.state.isLoading ? (
                    <div className="spinner-container" style={{ padding: "0.5rem 0" }}>
                        <div style={{ padding: "0 1rem" }}>
                            <Progress animated color="primary" value={100} style={{ height: "8px", borderRadius: 4 }} />
                        </div>
                        <div style={{ textAlign: "center", marginTop: "0.5rem", fontSize: "0.95rem", opacity: 0.9 }}>
                            Loading...
                        </div>
                    </div>
                ) : (
                    <Row>
                        <div className="col-md-10 my-3 col-xs-12">
                            <Select
                                ref={this.selectRef}
                                id="theme"
                                isMulti={!!sessionStorage.getItem("customer")}
                                options={options}
                                value={value}
                                onFocus={() => this.setState({ isSelectFocused: true })}
                                onBlur={() => this.setState({ isSelectFocused: false })}
                                onChange={(selectedOptions) => {
                                    const selected = Array.isArray(selectedOptions)
                                        ? selectedOptions.map(o => ({ id: o.value, title: o.label }))
                                        : selectedOptions ? [{ id: selectedOptions.value, title: selectedOptions.label }] : [];
                                    this.setState({ selectedSongBooks: selected });
                                }}
                                styles={customStyles}
                                placeholder="Select song books..."
                            />
                        </div>
                        <div className="col-md-2 my-3 col-xs-12">
                            <div className="d-flex gap-2">
                                <Button
                                    className="btn-icon"
                                    color="primary"
                                    disabled={!addButtonEnabled}
                                    onClick={this.addSongBooksToList}
                                >
                                    <RiAddLine />
                                    <span className="btn-inner--text">Add</span>
                                </Button>
                            </div>
                        </div>
                    </Row>
                )}
                <Row>
                    <div className="col-12 mt-3 mb-3">
                        <div className="pill-grid">
                            {this.state.chosenSongBooksButtons?.length ? this.state.chosenSongBooksButtons : <p>No selection made</p>}
                        </div>
                    </div>
                </Row>
            </div>
        );
    }
}

export default SongBooksDropdown;